import { ISorter } from "@/models/tables";
import i18n from "@/i18n";

export const ServerSorters: () => ISorter[] = () => [
  {
    field: "created_at",
    label: i18n.t("_.created_at").toString()
  },
  {
    field: "name",
    label: i18n.t("_modules.web_hosting.web_hosting.server_name").toString()
  }
];

export const TldDateCreatedSorter: () => ISorter = () => ({
  field: "created_at",
  label: i18n.t("_.date_created")
});

export const TldNameSorter: () => ISorter = () => ({
  field: "name",
  label: i18n.t("_modules.web_hosting.domains.domain_name")
});

export const TldsSorters: () => ISorter[] = () => [
  TldDateCreatedSorter(),
  TldNameSorter()
];
